'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;



// WEBPACK FOOTER //
// webpack:///node_modules/function-bind/index.js